export enum ROLE {
  ADMIN = 'Admin',
  ANALYST = 'Analyst',
  BI_ML_SPECIALIST = 'BI-ML Specialist',
}
